// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const translationKeys = {
   ABOUT_WIDGET_BUILDER: 'About Widget Builder',
   ABSTRACT: 'Abstract',
   ACCESS_TYPE_IN: 'Access this %{type} in',
   ACCESSIBLE_MENU: 'Accessible Menu',
   ADD_A_ROW: 'Add a row',
   ADD_A_ROW_MAX_REACHED: 'Adding not possible, maximum fields reached',
   ADD_FIELD: 'Add %{field}',
   ADD_RESULTS_BEYOND_COLLECTION: 'Add results beyond your library\'s collection',
   ADDRESS_PRIMARY: 'Primary address',
   ADDRESS_ALT: 'Alternate address',
   ADDRESSES: 'Address(es)',
   ADVANCED: 'Advanced',
   ADVANCED_LINE: 'Advanced Line',
   ADVANCED_LINK_TEXT: 'Advanced Link Text',
   ADVANCED_SEARCH: 'Advanced Search',
   ADVANCED_SEARCH_INPUT_SEARCH_TOGGLE: 'click to search',
   ADVANCED_SEARCH_DIALOG: 'Advanced Search Dialog',
   ADVANCED_SEARCH_CONTAINS: 'Contains',
   ADVANCED_SEARCH_CONTAINS_ALLWORDS: 'All words anywhere',
   ADVANCED_SEARCH_CONTAINS_ANYWORDS: 'Any of these words',
   ADVANCED_SEARCH_CONTAINS_EXACTMATCH: 'Exact match',
   ADVANCED_SEARCH_CONTAINS_BEGINSWITH: 'Begins with',
   ADVANCED_SEARCH_OTHER_FILTERS_LABEL: 'Other filters from your last search',
   ALERT_NAME_DOES_NOT_EXIST: 'Alert name does not exist',
   ALL_LOCATIONS: 'All Locations',
   ALL: 'All',
   AND_MORE: 'and more',
   MORE_OPTIONS: 'More Options',
   MORE_OPTIONS_EDIT_SEARCH_SCOPE: 'More options for editing search scope',
   ALTMETRICS: 'Altmetrics',
   ANY_TYPE: 'Any Type',
   APP_ERROR: 'Application Error',
   APP_ERROR_MSG: "Your search has failed to complete. Please try again.",
   APP_ERROR_MSG_400: "This search was unable to be fulfilled due to an invalid query.",
   APP_ERROR_MSG_429: "This search was unable to be fulfilled due to excessive use.",
   APP_IS_LOADING: 'Application is loading.',
   APP_MESSAGE: 'Application Message',
   APPLY: 'Apply',
   APPLY_TOOLTIP: 'Apply selected facets and refresh results',
   ASSESSED_DATE: 'Assessed Date',
   ASSESSED_DATE_EXPLANATION: 'The date the fine was assessed. This is the date the fine was created in the system.',
   ATTEMPT_TO_SAVE_ITEM: 'Attempting to save item.',
   AUTHOR: 'Author',
   AUTHENTICATION_ERROR_VALIDATE_ERROR: 'User could not be validated against external authentication service, please try again.',
   AUTHENTICATION_ERROR_REFRESH_ERROR: 'Session could not be refreshed, please log in again.',
   AUTHENTICATION_ERROR_UNKNOWN_ERROR: 'Unknown authentication error, please log in again.',
   AUTHENTICATION_ERROR_NOT_AUTHENTICATED: 'Not authenticated, maybe your session expired. Please log in again.',
   AUTHENTICATION_OPTIONS: 'Authentication options',
   AUTHORIZE_GOOGLE: 'Give Access to Google Drive',
   AVAILABILITY: 'Availability',
   AVAILABLE_IN_PRINT: 'Available in Print',
   AVAILABLE_ONLINE: 'Available Online',
   AVAILABLE_RTA_STATUS_AVAILABLE: 'Available',
   AVAILABLE_RTA_STATUS_UNKNOWN: 'Unknown',
   AVAILABLE_RTA_STATUS_NOT_AVAILABLE: 'No copies available',
   BACK: 'Back',
   BACK_TO_BASIC: 'Basic search',
   BACK_TO_SEARCH: 'Back to results',
   BACK_TO_TOP: 'Back to top',
   BARCODE: 'Barcode',
   BARCODES: 'Barcode(s)',
   BEYOND_HOLDINGS: 'Beyond Holdings',
   BIBTEX: 'BibTeX',
   BIRTH_DATE: 'Date of birth',
   BOOK_REVIEWS: 'Book Reviews',
   BOOKMARK_RESULT: 'Bookmark results',
   BOX_WIDTH: 'Box width',
   BULK_EXPORT_DEFAULT_MESSAGE: 'Hi,\n\nThe results for the search \"{query}\" are attached. \n\nPlease contact the library if you need additional help.\n\n Here is the link to your search: {summonUrl}',
   BULK_EXPORT_ERROR: 'An error occurred while exporting results. Please try again.',
   BULK_EXPORT_EMAIL_SUBJECT: 'CDI Batch Search Report',
   BULK_EXPORT_REPORT_TITLE: 'Bulk Export Report',
   BULK_EXPORT_SUCCESS: 'Export is in progress. It may take several minutes for the export to complete and the email to be sent.',   
   BY: 'by',
   CALENDAR_KEY_INSTRUCTION: 'Use the left and right arrow keys to select a desired publication date for which to filter the result set. The result set will automatically filter 2 seconds after selection.',
   CAN_BE_USED_FOR_X: 'Can be used for %{feature}',
   CANCEL: 'Cancel',
   CANCEL_FACET_SELECTIONS: 'Cancel without applying changes',
   CANCEL_HOLD_REQUEST_DATE: 'Date to cancel the request',
   CALL_NUMBER: 'Call Number',
   NO_CALL_NUMBER: 'No Call Number',
   CHANGES: 'changes',
   CHAPTERS: 'Chapters',
   CHAT: 'Chat',
   CHAT_IS_OFFLINE: 'Chat is offline',
   CHAT_WITH_LIBRARIAN: 'Chat with a Librarian',
   CHECK_AVAILABILITY: 'Check Availability',
   CHECK_LIBRARY: 'Check Library',
   CHECK_OUT_DATE: 'Check out date',
   CHECK_SPELLING: 'Check your spelling',
   CHECKED_OUT: 'Checked out',
   CHECKED_OUT_DAYS_LEFT: '%{daysLeft} days left',
   CHECKED_OUT_EMPTY: 'You have no checked out items',
   CHECKED_OUT_ERROR: 'There was an error retrieving your loans: %{error}',
   CHECKED_OUT_OVERDUE: 'Overdue',
   CHECKED_OUT_RENEW_SELECTED: 'Renew %{count} selected loans',
   CHECKED_OUT_RENEWAL_ERROR: 'An error occurred renewing the loan, try again later',
   CHECKED_OUT_RENEWAL_ERROR_403: 'The loan could not be renewed, it might be too soon',
   CHECKED_OUT_RENEWAL_ERROR_X: 'The loan could not be renewed: %{error}',
   CHECKED_OUT_RENEWAL_SOME_ERROR: 'An error occurred renewing %{number} loan(s), try again later',
   CHECKED_OUT_RENEWAL_SUCCESS: 'Loan successfully renewed',
   CHECKED_OUT_RENEWAL_SUCCESS_ALL: 'All loans successfully renewed',
   CHECKING_AVAILABILITY: 'Checking Availability',
   CHOOSE_CITATION_FORMAT: 'Choose a Citation Format',
   CHOOSE_FEEDBACK_OPTIONS: 'Choose one of the feedback options',
   CHOOSE_FORMAT: 'Choose Format',
   CITACE_COM: 'Citace.com',
   CITATIONS: 'Citations',
   CITATION_ONLINE: 'Citation Online',
   CITATION_PATH_START: 'You started here',
   CITATION_PATH_CURRENT: 'You are here',
   CITATIONS_FAILED_TO_LOAD: 'Citations failed to load.',
   CITATIONS_PROCESSING_ERROR: 'Citation processing error.',
   CITAVI: 'Citavi',
   CITE: 'Cite',
   CITES: 'Cites',
   CITE_THIS_ITEM: 'Cite this item',
   CITED_BY: 'Cited by',
   CLEAR: 'Clear',
   CLEAR_ALL: 'Clear all',
   CLEAR_ALL_ITEMS: 'Clear all items?',
   CLEAR_FILTERS: 'Clear Filters',
   CLEAR_FORM: 'Clear Form',
   CLICK_ICON_TO_SAVE_TO_THIS_FOLDER: 'Click the <i class=\'uxf-icon uxf-bookmark uxf-l\'></i> icon next to any search result to add it to this folder.',
   CLICK_ICON_TO_SAVE_SEARCH: 'Click "Save Search" at the top of the search results to add your search to this folder.',
   CLOSE: 'Close',
   CLOSE_MENU: 'Close Menu',
   CLOSE_WIDGETS: 'Close Widgets',
   CLOUD_STORAGE_API_ERROR: 'Received error when contacting',
   CLOUD_STORAGE_API_ERROR_NETWORK_ERROR: 'There was a problem with the network',
   CLOUD_STORAGE_AUTH_CANCELED: 'Authorization process canceled.',
   CLOUD_STORAGE_AUTH_ERROR: 'Auth token error. Please sign in again.',
   COLLAPSE: 'Collapse',
   COLLECT_AND_ORGANIZE_YOUR_RESEARCH: 'Collect & organize your research',
   CONTACT_LIBRARIAN_LINK: '<a href=\'%{url}\' target=\'_blank\'>Contact a librarian</a> for help',
   CONTENT_TYPE: 'Content Type',
   CONTENT_TYPE_ADVANCED_SEARCH: 'Content Type (in Advanced Search)',
   CONTRACT_TOPIC_EXPLORER: 'Collapse Topic Explorer',
   CONTRACT_AZ_SEARCH_WIDGET: 'Collapse Database Finder',
   COPIES: 'Copies',
   COPY: 'Copy',
   COPY_THE_CODE: 'Copy the code',
   COURSE_ID: 'Course ID',
   COURSE_RESERVE: 'Course Reserve',
   COURSE_RESERVES: 'Course Reserves',
   COURSE_RESERVES_SEARCH_BOX_PLACEHOLDER: 'Search by course code, name or instructor',
   COVERAGE: 'Coverage',
   COVERAGE_DETAILS: 'Coverage Details',
   COVERAGE_GAP_FROM_TO: 'No coverage %{gapRange}',
   COVERAGE_START_TO_PRESENT: '%{start} to present',
   COVERAGE_ZERO_START: 'No date',
   CREATE_REFWORKS_ACCOUNT: 'Create an EndNote Fusion account and store all your saved items permanently, manage documents and references, and collaborate with other researchers.',
   CUSTOM_DATES: 'Custom Dates',
   CUSTOM_DATES_BUTTON: 'Custom Dates Button',
   CUSTOM_SECTIONS: 'Custom Panel Sections',
   CUSTOMIZE_THE_WIDGET: 'Customize the widget',
   CUSTOMIZE_DATE_RANGE: 'Customize date range',
   DATABASE: 'Database',
   DATABASE_RECOMMENDATIONS: 'Database Recommendations',
   DATABASE_FINDER: 'Database finder',
   DATABASE_FINDER_ALT_NAMES: 'Alternate name(s):',
   DATABASE_FINDER_MESSAGE: 'Search here to find individual databases in our Database A-Z list.',
   DATABASE_FINDER_NO_RESULTS: 'Nothing found for your query.',
   DATABASE_FINDER_PAGING: 'Showing %{start}-%{end} of %{count} database results:',
   DATABASE_FINDER_BROWSE_LINK: 'Or <a href=\'%{url}\' target=\'_blank\'>click here to browse by subject.</a>',
   DATABASE_PAGER_MAX: 'Showing more results not supported. Please rephrase your query.',
   DATABASE_FINDER_SHOW_NEXT_X: 'next %{count}',
   DATABASE_FINDER_SHOW_PREVIOUS_X: 'previous %{count}',
   DATABASE_FINDER_SUBJECTS: 'Subject(s):',
   DATEFORMAT_Y: 'y',
   DATEFORMAT_M: 'm',
   DATEFORMAT_D: 'd',
   DATE_NEWEST: 'Date(newest)',
   DATE_OLDEST: 'Date(oldest)',
   DATE_PRESET_1Y: '1 year',
   DATE_PRESET_3Y: '3 years',
   DATE_PRESET_5Y: '5 years',
   DATE_PRESET_10Y: '10 years',
   DAYS_LEFT: 'Days left',
   DELETE: 'Delete',
   DESCRIPTION: 'Description',
   DETAIL_PAGE: 'Detail Page',
   DID_YOU_MEAN: 'Did you mean',
   DISCIPLINE: 'Discipline',
   DISCIPLINE_ADVANCED_SEARCH: 'Discipline (in Advanced Search)',
   DISSERTATIONS: 'Dissertations',
   DOC_INSIGHTS: 'Insights',
   DONE: 'Done',
   DONE_LOADING_MORE_FACETS: 'Done Loading More Facets',
   DONE_LOADING_RESULTS: 'Done Loading Results',
   DONT_TRACK_HISTORY: 'Don\'t Track My Reading History',
   DUE_BY: 'Due by',
   DUE_DATE: 'Due date',
   EASYBIB: 'EasyBib',
   EBOOK_FULL_TEXT_ONLINE: 'eBook Full Text Online',
   EDIT: 'Edit',
   EDIT_FIELD: 'Edit %{field}',
   EDITED_BY: 'Edited By',
   EMAIL: 'Email',
   EMAILS: 'Email(s)',
   EMAIL_PROCESSING_ERROR: 'Email processing error.',
   EMAIL_SENT_SUCCESSFULLY: 'Email Sent Successfully',
   EMAIL_THIS_ITEM: 'Email this item',
   END_OF_RESULTS: 'You\'ve reached the end of your results!',
   ENDNOTE: 'EndNote',
   ENTER_VALID_DATE: 'Enter a valid date',
   EXCLUDE: 'Exclude',
   EXCLUDE_X: 'Exclude %{what}',
   EXCLUDED: 'Excluded',
   EXCLUDE_FROM_RESULTS: 'Exclude from results',
   EXCLUDE_THIS_ITEM: 'Exclude this item',
   EXPAND: 'Expand',
   EXPAND_TOPIC_EXPLORER: 'Expand Topic Explorer',
   EXPAND_AZ_SEARCH_WIDGET: 'Expand Database Finder',
   EXPAND_YOUR_RESULTS: 'Expand your results',
   EXPANDED_RESULTS: 'Expanded results',
   EXPORT: 'Export',
   EXPORT_AS_WITH_ELLIPSIS: 'Export As...',
   EXPORT_RESULTS: 'Export Results',
   ONLY_FIRST_1000_RESULTS_EXPORTED: 'Only the 1st 1000 results will be exported.',
   EXPORT_LIMIT_LABEL: 'Exports are limited to 1000 results at a time.',
   EXPORT_AND_EMAIL_AS_CSV_X_RESULTS: 'Export & Email | CSV - %{count} results',
   EXPORT_TO: 'Export to',
   EXPORT_TO_WITH_ELLIPSIS: 'Export To ...',
   FACETS_MENU: 'Facets Menu',
   FACETS_EMPTY: 'No results found',
   FACETS_EXCLUDED: '%{count} excluded (click to move facets to top)',
   FACETS_INCLUDED: '%{count} included (click to move facets to top)',
   FEEDBACK: 'Feedback',
   FEEDBACK_PROCESSING_ERROR: 'Feedback processing error.',
   FILTER_FACET_TYPE: '%{filter_facet_type} Filter',
   FILTER_LIST: 'Filter list',
   FILTER_BY: 'Filter by',
   FINE_AMOUNT: '$%{amount}',
   FINE_FEE: 'Fine/Fee',
   FINE_ERROR: 'There was an error retrieving your fines: %{error}',
   FINE_NO_RESOURCE: 'No resource for this fine',
   FINES: 'Fines & Fees',
   FINES_EMPTY: 'You have no fine or fees',
   FIXED: 'Fixed',
   FILTERS: 'Filters',
   FLUID: 'Fluid',
   FOR_HELP_CONTACT_LIBRARY: 'For additional help, don\'t hesitate to contact the library.',
   FORMAT_PREVIEW: 'Format preview',
   FROM_DATE_BEFORE_TO: '\'From\' date should occur before \'To\' date',
   FROM_SOURCE: 'From %{source}',
   FULL_TEXT_ONLINE: 'Full Text Online',
   FULL_DETAILS_PAGE: 'Full Details Page >',
   GENERATING_SHORTENED: "Generating Shortened URL",
   GO_TO_SEARCH: 'Go back to search',
   GLANCEABILITY_ORIGINAL_RESEARCH: 'Original Research',
   GLANCEABILITY_PAGES: '%{n} pages',
   GLANCEABILITY_REVIEW_ARTICLE: 'Review Article',
   GLANCEABILITY_PRIMARY_SOURCE: 'Primary Source',
   GLANCEABILITY_PRE_PRINT: 'Preprint',
   GLANCEABILITY_ONLINE_FIRST: 'Online First Article',
   GLANCEABILITY_OPEN_EDUCATIONAL_RESOURCE: 'Open Educational Resource',
   GLANCEABILITY_RETRACTED_PUBLICATIONS: 'Retracted Publication',
   GLANCEABILITY_WITHDRAWN_PUBLICATIONS: 'Withdrawn Publication',
   GLANCEABILITY_RETRACTION_NOTICE: 'Retraction Notice',
   GLANCEABILITY_WITHDRAWAL_NOTICE: 'Withdrawal Notice',
   GLANCEABILITY_PUBLICATION_EXP_CONCERN: 'Publication with Expression of Concern',
   GLANCEABILITY_PUBLICATION_ADDENDUM: 'Publication with Addendum',
   GLANCEABILITY_PUBLICATION_CORRIGENDUM: 'Publication with Corrigendum',
   HEADER: 'Header',
   HEADER_COLOR: 'Header Color',
   HOLD_REQUEST_NOTE: 'Request note',
   HOME: 'Home',
   HOW_RATE_SATISFACTION: 'How would you rate your level of satisfaction?',
   IMAGE_RESULTS_FOR: 'Image results for',
   IMAGE_THUMBNAIL: 'Image Thumbnail',
   INCLUDE: 'Include',
   INCLUDE_THIS_ITEM: 'Include this item',
   INCLUDING: 'Including',
   INCLUDING_RESULTS_FOR: 'Including results for',
   INVALID_DATA_NOTICE: 'This form contains invalid data or is missing required fields and cannot be submitted at this time. Please make corrections to enable this button.',
   INSTRUCTOR: 'Instructor',
   IS_REQUIRED: 'is required',
   ISSN_EDIT_IN_OPTIONS: 'ISSN must be edited in the options modal',
   ISSUE: 'Issue',
   ITEM_HAS_BEEN_SAVED: 'Item has been saved.',
   ITEMS_AT_MY_INSTITUTION: 'Items at my institution',
   ITEMS_IN_LIBRARY_CATALOG: 'Items in the library catalog (includes mostly print and physical material)',
   JUST_SEARCH_QUERY: 'Just search %{query}',
   JOURNAL_TITLE: 'Journal Title',
   LANGUAGE: 'Language',
   LANGUAGE_ADVANCED_SEARCH: 'Language (in Advanced Search)',
   LAST_X_DAYS: 'Last %{x} days',
   LAST_12_MONTHS: 'Last 12 Months',
   LAST_3_YEARS: 'Last 3 years',
   LAST_5_YEARS: 'Last 5 years',
   _1_YEAR: '<font class=\'font-year\'>1</font> Year',
   _3_YEARS: '<font class=\'font-year\'>3</font> Years',
   _5_YEARS: '<font class=\'font-year\'>5</font> Years',
   _10_YEARS: '<font class=\'font-year\'>10</font> Years',
   LEARN_MORE: 'Learn more',
   LESS: 'Less',
   LIBRARY_ACCOUNT: 'Library Account',
   LIBRARY_ADVANCED_SEARCH: 'Library Location (in Advanced Search)',
   LIBRARY_CARD: 'Library Card',
   LIBRARY_CARD_DIALOG_CLOSE:"Library Card Dialog Close",
   LIBRARY_CARD_SORT_BY:"Library Card Sort By",
   LIBRARY_CARD_FEATURE: 'Library integration',
   LIBRARY_CARD_FEATURE_DESCRIPTION: 'Authenticate with your library system, so you can request items and interact with your account (if enabled by the library)',
   LIBRARY_CATALOG: 'Library Catalog',
   LIBRARY_NOTES: 'Library Notes',
   LIBRARY_REC: 'Library Recommendation',
   LIBRARY_SEARCH: 'Library Search',
   LIBRARY_THING: 'LibraryThing',
   LINK: 'Link',
   LINK_RESOLVER: 'Link Resolver',
   LIMIT_TO: 'Limit to',
   LINKS_COLOR: 'Links Color',
   LINKS_MENU: 'Links Menu',
   LOAD_MORE: 'Load more',
   LOADING: 'loading',
   LOADING_MORE_FACETS: 'Loading more facets',
   LOADING_PAGE_NUMBER: "Loading page %{number}",
   LOADING_PUBLIC_NOTES: 'Loading Public Notes',
   LOADING_RESULTS: 'Loading Results',
   LOADING_SYNDETICS_CONTENT: 'Loading Syndetics Plus content',
   LOCATION: 'Location',
   LOCATIONS: 'Locations',
   LOGIN_WITH: 'Log in with %{alias}',
   LOGIN_WITH_CAS: 'Log in with Library Account',
   LOGIN_WITH_SAML: 'Log in with SAML',
   LOGOUT_OF: 'Log out of %{provider}',
   MANAGE_READING_HISTORY: 'Manage My Reading History Via WebPac',
   MENU: 'Menu',
   MESSAGE: 'Message',
   MESSAGES: 'Messages',
   MESSAGES_EMPTY: 'You have no messages',
   MESSAGES_ERROR: 'There was an error retrieving your messages: %{error}',
   MESSAGES_FROM_LIBRARY: 'Message %{pluralChar} from the library:',
   MINIMIZE_NUMBER_OF_SEARCH_TERMS: 'Minimize number of search terms',
   MODAL_DIALOG: 'Modal Dialog',
   MORE: 'More',
   MORE_ACTIONS: 'More actions',
   MORE_BOOK_REVIEWS: 'More Book Reviews',
   MORE_DETAILS: 'More Details',
   MORE_FACETS_PANE: 'More Facets Pane',
   MOVE_BACKWARDS: 'Move backwards',
   MOVE_FORWARDS: 'Move forwards',
   MOTIVE: 'Motive',
   LOAD_MORE_FACETS: 'Load more facets',
   MUST_BE_MIN_LENGTH: 'Must be at least %{minLength} characters',
   MUST_BE_VALID: 'must be valid',
   MUST_CONTAIN_10_CHARS: 'must contain more than 10 characters',
   NAME: 'Name',
   NEW_SEARCH: 'New Search',
   NEW_SEARCH_MSG: 'You have started a new search. All filters, date restrictions, keywords and other elements of your previous searches have been cleared. If you want to include filters in any subsequent searches or limit your results in any way you will need to set them again.',
   NEWS_RESULTS_FOR: 'News results for',
   NEWSPAPER_ARTICLES: 'Newspaper articles',
   NEXT_PAGE: 'Next',
   NEXT_RESULT: 'Next Result',
   NO: 'No',
   NOTES: 'Notes',
   NO_RATING: 'No Rating',
   NO_RESOURCE_FOUND: 'Resource not found in Summon index',
   NO_RESULTS_FOR_ADV_SEARCH_CHECKBOX_LIST: 'Nothing matching \'%{query}\'',
   NO_RESULTS_FOR_CURRENT_FILTER: 'No results were found for this search with your current filter selections. Try %{linkStart}clearing your filters%{linkEnd} to improve your results',
   NO_SAVED_ITEMS_NOTICE: 'You haven\'t saved any items yet.',
   NO_SAVED_SEARCHES_NOTICE: 'You haven\'t saved any searches yet.',
   NOT_ALL_ARTICLES: "(may not contain all articles)",
   NOTE_NO_ACCESS_TO_ARTICLE: '<strong>Note:</strong> You do not have access to this article online',
   NOTE_SELECTED_ARTICLE_NOT_AVAILABLE: '<strong>Note:</strong> The article you selected is not available through these sources',
   OK: 'OK',
   ONLINE: 'online',
   OPEN_ACCESS: 'Open Access',
   OPEN_ACCESS_FILTER: 'Open Access (Filter)',
   OPEN_ACCESS_INDICATOR: 'Open Access (Indicator)',
   OPEN_ACCESS_ITEMS_ONLY: 'Open Access items only',
   OPEN_IN_NEW_TAB: 'Opens in a new tab',
   OPT_IN: 'Opt In',
   OPT_IN_OR_OUT: 'Opt In/Out',
   OPT_OUT: 'Opt Out',
   OPT_OUT_QUESTION: 'Opt out from history, deleting all entries?',
   OPTIONAL: 'Optional',
   OPTIONS: 'Options',
   OR: 'OR',
   OR_INCLUDE_SOURCES_OUTSIDE_LIBRARY: 'Or try %{linkStart}including sources outside of this library\'s collection%{linkEnd}',
   OTHER_AVAILABLE_SOURCES: 'Other Available Sources',
   PAGE_NUMBER: 'Page %{number}',
   PAGINATION: 'Pagination',
   PDF: 'PDF',
   PEER_REVIEW: 'Peer-Reviewed',
   PEER_REVIEWED_PUBLICATIONS: 'Peer reviewed publications',
   PERFORM_SEARCH_SEE_RESULTS:'Perform search to preview scope results',
   PERMANENT_LINK: 'Permanent Link',
   PERMISSION_REQUIRED: 'Permission Required',
   PERMANENT_LINK_COPIED_TO_CLIPBOARD: 'Permanent Link copied to clipboard.',
   PERMANENT_LINK_COPY_ERROR: 'Your browser does not support programmatic copying. Please try CTRL+C.',
   PERSONAL_DETAILS: 'Personal Details',
   PERSONAL_DETAILS_ERROR: 'There was an error retrieving your personal details: %{error}',
   PERSONAL_DETAILS_EMPTY_ERROR: 'There was an error retrieving your personal details',
   PERSONAL_DETAILS_UPDATE_SUCCESS: 'Personal Details updated successfully',
   PERSONAL_DETAILS_UPDATE_ERROR: 'There was an error in updating your personal details',
   PHONES: 'Phone Number(s)',
   PHONE_PRIMARY : 'Primary phone',
   PHONE_ALT : 'Alternate phone',
   PHONE_MOB : 'Mobile phone',
   PHYSICAL_BOOKS_LIBRARY_CATALOG: 'Physical Books in Library Catalog',
   PHYSICAL_COPY: 'Physical Copy',
   PICKUP_LOCATION: 'Pickup location',
   PICKUP_LOCATIONS_EMPTY: 'Pickup location alternatives unavailable',
   PIN: 'PIN',
   PIN_FACETS_TOOLTIP: 'Pin this menu in place so selecting multiple facets is easier',
   PLACEHOLDER_TEXT: 'Placeholder Text',
   PLEASE_RELOAD_TO_TRY_AGAIN: 'Please reload to try again.',
   PLEASE_TRY_AGAIN: 'Please try again.',
   POWERED_BY: 'Powered by',
   PREVIEW: 'Preview',
   PREVIEW_ENV_ERROR: 'Preview Site',
   PREVIEW_ENV_ERROR_MSG: '<strong>Preview is not a production site.</strong><br>If you are seeing this message, the system is currently unavailable due to scheduled maintenance. Please try again later.',
   PREVIEW_ADVICE: '<strong>Preview is not a production site.</strong><br><a href="https://knowledge.exlibrisgroup.com/Summon/Release_Notes/Summon%3A_Release_Preview_Environment" target="_blank">Click here for details on the Preview environment</a>',
   PREVIEW_SCOPE_RESULTS:'Preview scope results',
   PREVIOUS_PAGE: 'Previous',
   PREVIOUS_RESULT: 'Previous result',
   PRINT: 'Print',
   PRINT_CITATION: 'Print citation',
   PROVIDER: 'Provider',
   PROQUEST: 'ProQuest',
   PUB_DATE: 'Publication date',
   PUB_DATE_RANGE: 'Publication date range',
   PUB_DATE_RANGE_FROM: 'Publication date range from',
   PUB_DATE_RANGE_TO: 'Publication date range to',
   PUBLIC_NOTES: 'Public Notes',
   PUBLICATION_TITLE: 'Publication Title',
   PUBLISHER: 'Publisher',
   QUESTION_FROM_CHAT_DIALOG: 'Question from Chat Dialog',
   QUICK_LOOK: 'Quick Look',
   QUICKFILTER_REMOVE_OTHER_X: 'To apply, remove facet: "%{facet}"',
   READ_MORE: 'Read more',
   READING_HISTORY: 'Reading History',
   READING_HISTORY_INACTIVE: 'You have opted out from Reading History',
   READING_HISTORY_DELETE_SELECTED: 'Delete %{count} selected entries',
   READING_HISTORY_DELETION_ERROR: 'An error occurred deleting the entry, try again later',
   READING_HISTORY_DELETION_ERROR_ALL: 'An error occurred deleting the entries, try again later',
   READING_HISTORY_DELETION_SOME_ERROR: 'An error occurred deleting %{number} loan(s), try again later',
   READING_HISTORY_DELETION_SUCCESS: 'Entry successfully deleted',
   READING_HISTORY_DELETION_SUCCESS_ALL: 'All selected entries successfully deleted',
   READING_HISTORY_EMPTY: 'You have no reading history yet',
   READING_HISTORY_ERROR: 'There was an error retrieving your reading history: %{error}',
   READING_HISTORY_OPT_IN_ERROR: 'An error occurred in processing request to opt in, try again later',
   READING_HISTORY_OPT_OUT_ERROR: 'An error occurred in processing request to opt out, try again later',
   READING_HISTORY_OPT_OUT: 'Opt out from history',
   READING_HISTORY_OPT_OUT_SUCCESS: 'Successfully opted out from reading history and deleted it',
   RECOMMENDED_RESEARCH_GUIDES: 'Recommended Research Guides',
   RECORD_DETAILS: 'Record Details',
   REFERENCE_RESULTS_FOR: 'Reference results for',
   REFINE_PANE: 'Refine Pane',
   REFINE_SEARCH: 'Refine your search',
   REFWORKS: 'EndNote Fusion',
   REFWORKS_LOG_IN: 'EndNote Fusion Log In',
   RELATED_ARTICLES: 'Related Articles',
   RELATED_TOPICS: 'Related Topics',
   RELEVANCE: 'Relevance',
   RELOAD_AVAILABILITY: 'Reload Availability',
   REMEMBER_TO_SIGN_OUT: 'Remember to sign out if you are on a public computer.',
   REMOVE: 'Remove',
   REMOVE_EXCLUSION_FILTER: 'Remove exclude %{filter} filter',
   REMOVE_FILTER: 'Remove %{filter} filter',
   REMOVE_THIS_ITEM: 'Remove this item',
   REMOVING_THIS_ITEM: 'Removing this item',
   RENAME: 'Rename',
   RENEW: 'Renew',
   REQUEST: 'Request',
   REQUEST_RTA: 'Request item',
   REQUEST_DATE: 'Request date',
   REQUEST_NOT_ALLOWED: 'This item cannot be requested',
   REQUEST_CHECK_ALLOWED: 'Checking if item can be requested...',
   REQUESTED_ON: 'Requested on',
   REQUESTS: 'Requests',
   REQUESTS_COUNT: 'Requests (%{count})',
   REQUESTS_EMPTY: 'You have no requests',
   REQUESTS_MAY_NOT_BE_UP_TO_DATE: 'An item was recently requested, but it is not in this list yet. Please check again in about a minute.',
   REQUESTS_ERROR: 'There was an error retrieving your requests: %{error}',
   REQUESTS_CANCEL_SELECTED: 'Cancel %{count} selected holds',
   REQUESTS_CANCEL_SUCCESS: 'Hold successfully canceled',
   REQUESTS_CANCEL_ERROR: 'An error occurred canceling the hold, try again later',
   REQUESTS_CANCEL_SOME_ERROR: 'An error occurred canceling %{number} hold(s), try again later',
   REQUESTS_CANCEL_ERROR_404: 'The hold could not be found and  might already be canceled.',
   REQUESTS_CANCEL_SUCCESS_ALL: 'All holds successfully canceled',
   REQUEST_BOOK: 'Request book',
   REQUEST_HOLD_CREATED: 'Your request has been created',
   REQUEST_HOLD_FAILED: 'Request failed. %{reason}',
   REQUEST_HOLD_UPDATED: 'Your hold has been updated',
   REQUEST_ERROR_UNKNOWN: 'Unknown error',
   TO_CONTINUE_ACCESS_THROUGH_YOUR_INSTITUTION: 'To continue, access through your institution',
   REQUIRED: 'Required',
   RESEARCH_ASSISTANT: 'Research Assistant',
   RESEARCH_ASSISTANT_FEATURE: 'Research Assistant',
   RESEARCH_ASSISTANT_FEATURE_DESCRIPTION: 'Authenticate in order to access Research Assistant new feature',
   RESERVE: 'Reserve',
   RESULT_ITEM: 'Result Item',
   RESULTS_COLOR: 'Results Color',
   RESULTS_FOR: 'Results for ',
   RESULTS_IN_POPUP: 'Results in Popup',
   RESULTS_COUNT: '%{count} results',
   RESULTS_COUNTER: '%{current} of %{total} results',
   RESULTS_COUNTER_MOBILE: '%{current} of %{total}',
   RESULTS_COUNT_ABOUT: 'About %{count} results',
   RESULTS_SORTED_BY_LINK: 'Sorted by %{linkStart}%{sortValue}%{linkEnd}',
   REVIEWS: 'Reviews',
   REVIEWS_AND_CHAPTERS: 'Reviews and Chapters',
   REVEAL_FIELD_INSTRUCTIONS: 'Add or change %{field}',
   ROLE: 'Role',
   ROLLUP_IMAGE: 'Rollup Image',
   RSS_FEED_FOR_RESULTS: 'RSS 2.0 feed for current search',
   SAVE: 'Save',
   SAVE_FOR_THIS_VISIT: 'Save for this visit only',
   SAVE_FLOW_ERROR: "The document(s) you have selected failed to save to EndNote Fusion.",
   SAVE_FLOW_ERROR_AUTH: "Your session has expired, please <em>Log in</em> again.",
   SAVE_SEARCH: "Save Search",
   SAVE_SEARCH_DUPLICATED: "This search already exists",
   SAVE_SEARCH_AND_ITEM: "Save Search and Save Item",
   SAVE_SEARCH_DESCRIPTION: "Save your search and store them in the cloud, you can retrieve them on any computer where you can log in.",
   SAVE_THIS_ITEM: 'Save this item',
   SAVE_THIS_SEARCH: 'Save current search and filters',
   SAVED_ITEMS: 'Saved Items',
   SAVED_ITEMS_DIALOG: 'Saved Items Dialog',
   SAVED_SEARCHES: 'Saved Searches',
   SAVED_SEARCHES_DIALOG: 'Saved Searches Dialog',
   SAVED_SEARCHES_LIMIT: 'You have reached the Saved Searches limit. Please remove any unused Saved Searches before saving more.',
   SAVING_THIS_ITEM: 'Saving this item',
   SCHOLARLY_PEER_REVIEW: 'Scholarly & Peer-Reviewed',
   SCHOLARLY_MATERIALS: 'Scholarly materials, including peer-reviewed',
   SCOPUS: 'Scopus',
   SEARCH: 'Search',
   SEARCH_BUTTON_TEXT: 'Search Button Text',
   SEARCH_FIELD: 'Search field ',
   SEARCH_FOR_X_RETURNED_0: 'Your search for %{query} returned 0 results',
   SEARCH_INSTEAD_FOR: 'Search instead for',
   SEARCH_LOGIC: 'Search logic ',
   SEARCH_MODIFIER: 'Search modifier ',
   SEARCH_NAME: 'Search name',
   SEARCH_OPTIONS: 'Search Options',
   SEARCH_QUERY_HELP: 'Search Query Help',
   SEARCH_RESULTS: 'Search Results',
   SEARCH_RESULTS_FORMAT: 'Search Results Format',
   SEARCH_RESULTS_FORMAT_ALT: 'As shown on search results',
   SEARCH_SAVED_FOR_SESSION: 'Search saved for this session',
   SEARCH_SAVED: 'Search saved',
   SEARCH_SCOPE_TITLE: 'Collections to search for',
   SEARCH_VALUE: 'Search value ',
   SEARCH_WITHIN:'Search within',
   SEARCH_WITHIN_JOURNAL:'Search within journal',
   SECONDARY_SEARCH_TITLE: '%{secondary} Search',
   SECONDARY_SEARCH_MESSAGE: 'Search here to find records at %{secondary}.',
   SECONDARY_RESULTS_MESSAGE: 'Showing %{max} of %{count} <a href=\'%{url}\' target=\'_blank\'>%{secondary}</a> results:',
   SECTION: 'Section',
   SEE_ALL_X: 'See all (%{x})',
   SELECT_ALL: 'Select all %{count}',
   SELECT_MULTIPLE_FACETS: 'Select multiple facets before refreshing results',
   SELECT_NONE: 'Deselect all',
   SELECT_PHONE_TYPE: 'Select phone type',
   SELECT_PICKUP_LOCATION: 'Select pickup location (required)',
   SELECT_WIDET_TYPE_NOTICE: 'Once you’ve formatted your default search the way you like, click on &quot;Select Widget Type&quot; on the process flow at the top of the page. This will return you to this widget builder page with your formatted search ready for use.',
   SELECT_WIDGET_TYPE: 'Select Widget type',
   SELECTED: 'Selected',
   SELECTED_COUNT: '%{count} selected',
   SELECTED_ITEM: '(Selected item)',
   SEND: 'Send',
   SEND_EMAIL: 'Send Email',
   SEND_EMAIL_TO: 'Send email to',
   SEND_EMAIL_FROM: 'From',
   SEND_ME_COPY_OF_EMAIL: 'Send me a copy of this email',
   SEND_TO: 'Send to',
   SHARE_ACTIONS: 'Share',
   SHARE_MESSAGE_X_X_MESSAGE_URL: 'I found "%{message}" via %{url}',
   SHARE_MESSAGE_X_MESSAGE: 'I found "%{message}"',
   SHARE_WITH_PROVIDER_X: 'Share with %{service}',
   SHOW: 'Show',
   SHOWING_RESULTS_FOR: 'Showing results for',
   SHOW_ONLY: 'Show only',
   SIGN_IN_WITH_CLOUD_STORAGE: 'Sign in with the cloud storage provider of your choice',
   SIGN_IN: 'Sign in',
   SIGN_IN_TO_CONTINUE: 'Sign in to continue',
   SIGN_IN_TO_SAVE_PERMANENTLY: 'Sign in to save permanently',
   SIGN_IN_WITH_X: 'Sign in with %{x}',
   SIGN_OUT: 'Sign out',
   SIGN_OUT_FROM_X: 'Sign out from %{x}',
   SIGN_OUT_FROM_X_CONFIRM: 'You have signed out from %{x}. Remember to close your %{x} session if on a shared computer.',
   SIGN_OUT_OF_X: 'Sign out of %{x}',
   SIGN_UP_FREE: 'Sign up (free)',
   SIGNED_IN_AS: 'Signed in as',
   SIGNED_IN: 'Signed in',
   SIGNED_IN_WITH: 'Signed in with %{provider}',
   STREAMING_VIDEO: 'Streaming video',
   SUBJECTS: 'Subjects',
   SUBJECT_TERMS: 'Subject Terms',
   SUBJECT_KEYWORDS: 'Subject Keywords',
   LEAVE:'Leave',
   LOGGED_OUT_SUCCESS: 'You have logged out successfully',
   LOGGED_OUT_FORCED: 'You are logged out automatically',
   LOGGED_OUT_FORCED_DUE: 'You are logged out automatically because "%{reason}"',
   LOGGED_OUT_ALREADY: 'You are already logged out.',
   LOG_IN: 'Log in',
   LOG_IN_OUT: 'Log in/out',
   LOG_IN_EXPIRED: 'Your session has expired...',
   LOG_IN_MISSING_PERMISSIONS_GOOGLE_ONLY: 'To save your searches or items, give access to Google Drive.',
   LOG_IN_MISSING_PERMISSIONS: 'To save your searches or items, allow access to Google Drive',
   LOG_IN_SUCCESS: 'Logged in successfully',
   LOG_IN_ERROR_SIERRA: 'Library services unavailable. Could not login.',   
   LOG_OUT: 'Log out',  
   LOGOUT_SUMMON_OR_PROVIDER: 'Log out of Summon only, or log out everywhere for %{provider}',
   LOGOUT_EVERYWHERE: 'Everywhere',
   LOGOUT_EVERYWHERE_LINK_X: 'Log out everywhere for %{provider}',
   LOGOUT_SUMMON_ONLY: 'Summon only',
   // @ts-expect-error TS(1117) FIXME: An object literal cannot have multiple properties ... Remove this comment to see the full error message
   OPTIONS: 'Options',
   SKIP_THIS_SECTION: 'Skip this section',
   SKIP_FILTERS_SECTION: 'Skip filters section',
   SKIP_RESULTS_SECTION: 'Skip results section',
   SKIP_MORE_CONTENT_PANEL: 'Skip more content panel',
   SKIP_TO_CONTENT: 'Skip to main content',
   SKIP_TO_FILTERS: 'Skip to filters',
   SKIP_TO_MORE_CONTENT: 'Skip to more content',
   SKIP_TO_SEARCH_BOX: 'Skip to search box',
   SKIP_TO_SEARCH_RESULTS: 'Skip to search results',
   SORT_ALPHA: 'Sort Alphabetically',
   SORT: 'Sort',
   SORT_BY: 'Sort by',
   SORT_BY_ALPHABET: 'Alphabetically',
   SORT_BY_NEWEST_DATE: 'Sort by newest date',
   SORT_BY_OLDEST_DATE: 'Sort by oldest date',
   SORT_BY_RANK: 'Sort by Rank',
   SORT_BY_RELEVANCE: 'Sort by relevance',
   SORT_BY_RESULT_COUNT: 'Number of results',
   SORT_BY_SELECTED: 'Included and excluded',
   SORT_ORDER: 'sortOrder',
   SORT_BY_AUTHOR: 'Sort by author',
   SORT_BY_TITLE: 'Sort by title',
   SOURCE: 'Source',
   SORRY_UNABLE_RETRIEVE_RECOMMENDATIONS: 'Sorry we were unable to retrieve recommendations at this time',
   START_WHATSAPP_CHAT: 'Start WhatsApp Chat',
   STATUS: 'Status',
   SUGGESTED_BY: 'suggested by',
   SUGGESTED_LIBRARIAN: 'Suggested Librarian',
   SUGGESTIONS: 'Suggestions',
   SUGGESTIONS_TO_IMPROVE_SEARCH: 'Here are some suggestions to improve your search',
   SUMMON: 'Summon',
   TAG_LINE: 'Tag Line',
   TAG_LINE_COLOR: 'Tag Line Color',
   TAG_LINE_TEXT: 'Tag Line Text',
   TITLE: 'Title',
   TITLE_COLOR: 'Title Color',
   TITLE_TEXT: 'Title Text',
   TITLE_LINK:'Title Link',
   DEFAULT_THUMBNAIL_URL: 'Default Thumbnail URL',
   SEARCH_URL: 'Search URL',
   SEARCH_CAROUSEL_WIDTH: 'Search Carousel Width',
   SEARCH_CAROUSEL_RESULT_LIMIT: 'The carousel will display the top 10 results from the search',
   TITLE_FONT_WEIGHT: 'Title Font Weight',
   TITLE_FONT_SIZE: 'Title Font Size',
   DESCRIPTION_FONT_COLOR: 'Description Font Color',
   DESCRIPTION_FONT_WEIGHT: 'Description Font Weight',
   DESCRIPTION_FONT_SIZE: 'Description Font Size',
   IMAGE_HEIGHT: 'Image Height',
   BULLET_SPACING: 'Bullet Spacing',
   TO_DATE: 'To date, Format %{formatToDisplay}',
   FROM_DATE: 'From date, Format %{formatToDisplay}',
   TO_BEGIN_CREATE_BLANK_SEARCH: 'To begin, create a blank search, applying any facets or limiters you’d like to be default for your search widget.',
   TO_PREVIEW_WIDGET: 'To preview a widget you must %{linkStart}select a widget type%{linkEnd}',
   TO_SHOW_CODE_FOR_WIDGET: 'To show the code for a widget you must %{linkStart}select a widget type%{linkEnd}',
   TO_SHOW_OPTIONS_FOR_WIDGET: 'To show options for a widget you must %{linkStart}select a widget type%{linkEnd}',
   TO_CREATE_SEARCH_FOR_WIDGET: 'To create a search for a widget you must %{linkStart}select a widget type%{linkEnd}',
   TOPIC: 'topic',
   TOPIC_SUMMARY: 'Topic Summary',
   TOTAL: 'Total $%{total}',
   TRACK_HISTORY: 'Track My Reading History',
   TRY_ANOTHER_SEARCH: 'Don\'t see what you are looking for? Try one of these searches',
   TRY_INCLUDE_SOURCE_OUTSIDE_LIBRARY_COLLECTION: 'Try %{linkStart}including sources outside of the library\'s collection%{linkEnd}',
   TRY_SEARCHING_ALL:'Try %{linkStart}searching All%{linkEnd}',
   TYPE: 'Type',
   TYPE_OF_FEEDBACK: 'Type of feedback',
   USE_EMAIL_TO_SEND_QUESTION: 'Please use the email tab to send us your question.',
   VIEW_ALL_SELECTED: 'View All Selected',
   VIEW_LESS: 'View Less',
   VIEW_SAVED: 'View Saved',
   VIEW_IN_CLASSIC_CATALOG: 'View in classic catalog',
   VIEW_CITATION_PATH: 'View your citation path',
   VIEW_DELIVERY_OPTIONS: 'View Delivery Options',
   VIEW_IN_EPORTAL: 'View in E-Journal Portal',
   VIEW_SAVED_ITEM_COUNT:'View saved %{count} item',
   VIEW_SAVED_ITEMS_COUNT:'View saved %{count} items',
   VIEW_SAVED_SEARCH_COUNT:'View saved %{count} search',
   VIEW_SAVED_SEARCHES_COUNT:'View saved %{count} searches',
   VOLUME: 'Volume',
   VOL: 'Vol',
   WHAT_SEARCHING_FOR: 'What are you searching for?',
   WEB_OF_SCIENCE: 'Web of Science',
   WEB_OF_SCIENCE_CITATIONS: 'Web of Science Citations',
   WHY_IS_RESULT_HERE: 'Why is this result here?',
   WIDGET_BUILDER: 'Widget Builder',
   YEAR: 'Year',
   YES: 'Yes',
   YOU_ARE_LEAVING_SCOPE: 'You are about to leave',
   YOUR_EMAIL: 'Your Email',
   YOUR_MESSAGE: 'Your Message',
   YOUR_QUERY_MATCHED_INDEXED_FULL_TEXT: 'Your query matched the indexed full text of this document.',
   ZOTERO: 'Zotero',
   FEWER_SEARCH_OPTIONS: 'Fewer search options',
   MORE_SEARCH_OPTIONS: 'More search options',
   // @ts-expect-error TS(1117) FIXME: An object literal cannot have multiple properties ... Remove this comment to see the full error message
   COPIES: 'Copies',
   INCLUDE_MATCHES_IN_FULL_TEXT: 'Include matches in Full Text',
   INCLUDE_MATCHES_IN_FULL_TEXT_NO_RESULTS: 'Try %{linkStart}including matches in Full Text%{linkEnd}',
   COMBINE_INCLUDE_MATCHES_IN_FULL_TEXT_AND_DISABLE_RESULTS_BEYOND_COLLECTION : 'Try %{linkStart}searching everything (sources outside the library collection and full text)%{linkEnd}',
}
angular.module('summonApp.constants')
   .constant('$translationKeys', translationKeys)
